<template>
  <div class="main-wrapper">
    <div class="content main_content">
      <side-menu></side-menu>

      <operator-sidebar v-if="isOperator"></operator-sidebar>

      <chat-sidebar v-if="currentChatUser"
                    :class="{'sidebar-border-l-0': isOperator}"
      ></chat-sidebar>

      <chat-content></chat-content>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  computed: {
    ...mapGetters({
      isOperator: 'isOperator',
      currentChatUser: 'chat/currentChatUser',
      conversations: 'chat/conversations',
    }),
  },

  created() {
    if (this.$route.params.id) {
      const conversation = this.conversations.find(e => e.user?.username === this.$route.params.id);
      if (!conversation) {
        this.$router.replace('/chat');
      }
    }
  },
}
</script>
